<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">


  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       empty-text="데이타가 없습니다">
        <el-table-column
      align="center" label="리턴">
      <template slot-scope="scope">
        
          <el-button type="primary" size="mini" plain @click="todayRound(scope)" :disabled="scope.row.btn1">리턴</el-button>
        
        
      </template>
      </el-table-column>
        <el-table-column
      align="center" label="게임">
      사다리
    </el-table-column>
      
   
         <el-table-column
        
        label="횟차" prop="todayRound" align="center">
        
      </el-table-column> 
       <el-table-column
        
        label="불러오기"   align="center" class="d-flex  align-items-center" >
        <template slot-scope="scope">
         
        <el-button type="success" icon="el-icon-upload" class="ml-2 mr-2" :disabled="scope.row.btn2" style="padding:0 15px;line-height:28px;height:28px;"></el-button>
         
       

      </template>
        
      </el-table-column> 
   
       <el-table-column
        
        label="시간" prop="time" align="center" width="110">
         <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.time">
          </el-input>
          </template>
      </el-table-column> 
     
      <el-table-column
        
        label="좌우" prop="s" align="center" width="100">
         <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.s"></el-input>
          </template>
      </el-table-column> 
       <el-table-column
        
        label="줄" prop="l" align="center" width="100">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.l"></el-input>
          </template>
      </el-table-column> 
        <el-table-column
        
        label="홀짝" prop="o" align="center" width="100">
        <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.o"></el-input>
          </template>
      </el-table-column> 
        
       <el-table-column
      align="center" width="150" label="수정">
      <template slot-scope="scope">
        
          <el-button type="primary" size="mini" @click="edit(scope)" :disabled="scope.row.btn3">등록</el-button>
        
        
      </template>
      </el-table-column>
       <el-table-column
        
        label="배팅금액" prop="total" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.total)}}</template>
      </el-table-column>
     
      <el-table-column
        
        label="적중금" prop="total_e" align="center" >
        <template slot-scope="scope">{{ formatMoney(scope.row.total_e)}}</template>
      </el-table-column>
      </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
        
				
</div>
 </template>

 <script>

    export default {
    
    	data(){
    		return{
    		domain:window.sessionStorage.getItem('domain'),
          optvalue:[
           {
              label:'1',
              value:'1'
            },
             {
              label:'2',
              value:'2'
            },
             {
              label:'3',
              value:'3'
            },


          ],
          valuenum:'1',
    	
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 tableData: [],
			       currentPage:1,
             disabled:false
			    
              
			         
			 
    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
   
    	methods:{
         todayRound(e){
          this.$confirm('리턴하시겠습니까', '알림', {
          confirmButtonText: '확인',
          cancelButtonText: '취소',
          type: 'warning'
        }).then(() => {
        
          e.row.btn1=true
          let token=window.sessionStorage.getItem('user');
           this.$axios({
                      method:'post',
                      url:this.domain+'/admin/sadari_res_cancel_bg?id='+e.row.id,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },  
                     
                  }).then((response) =>{
                    e.row.btn1=false
                   
                   if(response.data.code==200){
                       
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })   
                    }else{
                      this.$message.error(response.data.msg)
                    }
                  
                    this.getList()
                   
                  }).catch((error) =>{
                      e.row.btn1=false
                      console.log(error)       
                  })
         
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: '취소됨'
          });          
        });
         
          
            
         
        },
          edit(e){
              this.$confirm('등록하시겠습니까?', '알림', {
              confirmButtonText: '확인',
              cancelButtonText: '취소',
              type: 'warning'
            }).then(() => {
            
                    e.row.btn3=true
          let token=window.sessionStorage.getItem('user');
           this.$axios({
                      method:'post',
                      url:this.domain+'/admin/sadari_result_up_bg',
                      data:{
                          l:e.row.l,
                          o:e.row.o,
                          s:e.row.s,
                          time:e.row.time, 
                          id:e.row.id,
                      
                      
                         
                        },   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                     e.row.btn3=false

                   if(response.data.code==200){
                       
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })   
                    }else{
                      this.$message.error(response.data.msg)
                    }
                    this.getList()
                    
                   
                  }).catch((error) =>{
                      console.log(error)
                       e.row.btn3=false     
                  })

            }).catch(() => {
            this.$message({
              type: 'info',
              message: '취소됨'
            });          
        });
          
         
            
         
        },
    		
			
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			    
       
    		getList(){

    		
              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/sadari_result_bg?page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                   //  console.log('tableData=',response.data.data.data)
                     let data = response.data.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     
                     this.loading =false
               
            }).catch((error) =>{
            	

               this.$message.error(error);
              this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    	
    
    		
    	}
  }
</script>

 <style scoped>


</style>


// WEBPACK FOOTER //
// src/views/sadari_bg/list.vue